import { useState, useEffect } from 'react';
import { getLinks } from '../api/links';

function LandingPage() {
  const inquiryEmail = process.env.REACT_APP_INQUIRY_EMAIL || 'Skeetbites@gmail.com';
  const instagramUrl = process.env.REACT_APP_INSTAGRAM_URL || 'https://www.instagram.com/the_mosquito__bites/';
  const [links, setLinks] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchLinks();
  }, []);

  const fetchLinks = async () => {
    try {
      const data = await getLinks();
      setLinks(data);
    } catch (error) {
      console.error('Failed to fetch links:', error);
    } finally {
      setLoading(false);
    }
  };

  if (loading) {
    return (
      <div className="landing-page">
        <div className="loading">Loading...</div>
      </div>
    );
  }

  return (
    <div className="landing-page">
      <div className="profile-section">
        <img className="name-logo" src="/name-logo.PNG" alt="Jackie and the Mosquito Bites" />
        <p className="profile-bio">Check out the links below!</p>
        <div className="social-links">
          <a className="social-icon" href={`mailto:${inquiryEmail}`} aria-label="Email">
            <svg viewBox="0 0 24 24" role="img" aria-hidden="true">
              <path d="M3 6.75A1.75 1.75 0 0 1 4.75 5h14.5A1.75 1.75 0 0 1 21 6.75v10.5A1.75 1.75 0 0 1 19.25 19H4.75A1.75 1.75 0 0 1 3 17.25V6.75Zm1.83-.25 7.17 5.38 7.17-5.38H4.83Zm14.67 1.88-6.98 5.23a.9.9 0 0 1-1.04 0L4.5 8.38v8.87c0 .14.11.25.25.25h14.5a.25.25 0 0 0 .25-.25V8.38Z" />
            </svg>
          </a>
          <a
            className="social-icon"
            href={instagramUrl}
            target="_blank"
            rel="noopener noreferrer"
            aria-label="Instagram"
          >
            <svg viewBox="0 0 24 24" role="img" aria-hidden="true">
              <path d="M7.5 3h9A4.5 4.5 0 0 1 21 7.5v9a4.5 4.5 0 0 1-4.5 4.5h-9A4.5 4.5 0 0 1 3 16.5v-9A4.5 4.5 0 0 1 7.5 3Zm0 1.5A3 3 0 0 0 4.5 7.5v9a3 3 0 0 0 3 3h9a3 3 0 0 0 3-3v-9a3 3 0 0 0-3-3h-9Zm10.13 1.62a1.12 1.12 0 1 1 0 2.25 1.12 1.12 0 0 1 0-2.25ZM12 7.5A4.5 4.5 0 1 1 7.5 12 4.5 4.5 0 0 1 12 7.5Zm0 1.5A3 3 0 1 0 15 12a3 3 0 0 0-3-3Z" />
            </svg>
          </a>
        </div>
      </div>

      <div className="links-container">
        {links.length === 0 ? (
          <div className="link-button" style={{ opacity: 0.7 }}>
            No links yet
          </div>
        ) : (
          links.map((link) => (
            <a
              key={link.id}
              href={link.url}
              target="_blank"
              rel="noopener noreferrer"
              className="link-button"
            >
              {link.title}
            </a>
          ))
        )}
      </div>
    </div>
  );
}

export default LandingPage;
